import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ReactSelect from '../../components/ReactSelect';
import getData from './../../data-services/api';
import { withRouter } from 'react-router-dom';
import { withFormik } from 'formik';
import { compose } from 'react-apollo';
import * as Yup from 'yup';
import client from './../../utils/apolloClient';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';
import IconButton from '@material-ui/core/IconButton';
import MySnackbar from './../../components/MySnackbar';
import Snackbar from '@material-ui/core/Snackbar';

const queryString = require('query-string');
const styles = (theme) => ({});

class AddEditOutlet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            open: false,
            // snackbarOpen:false,
            outletid: queryString.parse(window.location.search).outletid,
            isDisabled: !!queryString.parse(window.location.search).outletid,
        };
    }
    async componentDidMount() {
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                this.setState({
                    userData: data.user,
                });
            });

        if (this.state.outletid) {
            if (this.state.userData && this.state.userData.sfid) {
                const { result } = await getData(
                    `select outletName__c,Outletcode__c,Mobile_No__c,Address__c,City_Town__c,Region__c,State__c,District__c,wss_tty_name__c,WSS_CODE__c,WSS_Phone__c,tsi_tty_name__c,TTY_Code__c,TSI_TTY_Phone__c,Cluster__c,Cluster_BM_Mobile_no__c,CMDI_Name__c,Cluster_Code__c,rsm_mis_name__c,rsm_phone__c, id from  Salesforce.outlets__c where cmdi_name__c='${this.state.userData.sfid}' and id = '${this.state.outletid}'`
                );
                if (result) {
                    this.props.setValues(result[0]);
                }
            }
        } else {
        }
    }

    handleSnackbarClick = () => {
        this.props.setStatus({ snackbarOpen: true });
    };

    handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.props.setStatus({ snackbarOpen: false });
    };

    handleEditForm = () => {
        this.setState({ isDisabled: !this.state.isDisabled });
    };

    render() {
        const { classes, handleChange, errors, values, status, touched, history } = this.props;
        const isCMDI = this.state.userData
            ? this.state.userData.role === 'CMDI'
                ? true
                : false
            : false;
        const { isDisabled } = this.state;
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            Outlet
                        </Typography>
                    </Toolbar>
                </AppBar>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (this.props.isValid) {
                            this.handleEditForm();
                        }
                        this.props.handleSubmit(e);
                    }}
                >
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Outlet Name
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="outletname__c"
                                    placeholder="Outlet Name"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.outletname__c}
                                    error={errors.outletname__c && touched.outletname__c}
                                    FormHelperTextProps={{
                                        error: errors.outletname__c && touched.outletname__c,
                                    }}
                                    helperText={
                                        errors.outletname__c && touched.outletname__c
                                            ? errors.outletname__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Outlet Code
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="outletcode__c"
                                    placeholder="Outlet Code"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.outletcode__c}
                                    error={errors.outletcode__c && touched.outletcode__c}
                                    FormHelperTextProps={{
                                        error: errors.outletcode__c && touched.outletcode__c,
                                    }}
                                    helperText={
                                        errors.outletcode__c && touched.outletcode__c
                                            ? errors.outletcode__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Mobile No
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="mobile_no__c"
                                    placeholder="Mobile No"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.mobile_no__c}
                                    error={errors.mobile_no__c && touched.mobile_no__c}
                                    FormHelperTextProps={{
                                        error: errors.mobile_no__c && touched.mobile_no__c,
                                    }}
                                    helperText={
                                        errors.mobile_no__c && touched.mobile_no__c
                                            ? errors.mobile_no__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Address
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="address__c"
                                    placeholder="Address"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.address__c}
                                    error={errors.address__c && touched.address__c}
                                    FormHelperTextProps={{
                                        error: errors.address__c && touched.address__c,
                                    }}
                                    helperText={
                                        errors.address__c && touched.address__c
                                            ? errors.address__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    City/Town
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="city_town__c"
                                    placeholder="City Town"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.city_town__c}
                                    error={errors.city_town__c && touched.city_town__c}
                                    FormHelperTextProps={{
                                        error: errors.city_town__c && touched.city_town__c,
                                    }}
                                    helperText={
                                        errors.city_town__c && touched.city_town__c
                                            ? errors.city_town__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    District
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="district__c"
                                    placeholder="District"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.district__c}
                                    error={errors.district__c && touched.district__c}
                                    FormHelperTextProps={{
                                        error: errors.district__c && touched.district__c,
                                    }}
                                    helperText={
                                        errors.district__c && touched.district__c
                                            ? errors.district__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    State
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <ReactSelect
                                    isDisabled={isDisabled || !isCMDI}
                                    name="state__c"
                                    onChange={(e) => {
                                        this.props.setFieldValue('state__c', e.value);
                                        this.props.setFieldValue('state__c_label', e.label);
                                    }}
                                    error={errors.state__c && touched.state__c}
                                    value={{
                                        value: values.state__c,
                                        label: values.state__c_label,
                                    }}
                                    placeholderText="Select State"
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Region
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="region__c"
                                    placeholder="Region"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.region__c}
                                    error={errors.region__c && touched.region__c}
                                    FormHelperTextProps={{
                                        error: errors.region__c && touched.region__c,
                                    }}
                                    helperText={
                                        errors.region__c && touched.region__c
                                            ? errors.region__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    WSS Name
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="wss_tty_name__c"
                                    placeholder="WSS Name"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.wss_tty_name__c}
                                    error={errors.wss_tty_name__c && touched.wss_tty_name__c}
                                    FormHelperTextProps={{
                                        error: errors.wss_tty_name__c && touched.wss_tty_name__c,
                                    }}
                                    helperText={
                                        errors.wss_tty_name__c && touched.wss_tty_name__c
                                            ? errors.wss_tty_name__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    WSS Code
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="wss_code__c"
                                    placeholder="WSS Code"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.wss_code__c}
                                    error={errors.wss_code__c && touched.wss_code__c}
                                    FormHelperTextProps={{
                                        error: errors.wss_code__c && touched.wss_code__c,
                                    }}
                                    helperText={
                                        errors.wss_code__c && touched.wss_code__c
                                            ? errors.wss_code__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    WSS Phone No.
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="wss_phone__c"
                                    placeholder="WSS Phone"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.wss_phone__c}
                                    error={errors.wss_phone__c && touched.wss_phone__c}
                                    FormHelperTextProps={{
                                        error: errors.wss_phone__c && touched.wss_phone__c,
                                    }}
                                    helperText={
                                        errors.wss_phone__c && touched.wss_phone__c
                                            ? errors.wss_phone__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    TTY Name
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="tsi_tty_name__c"
                                    placeholder="TTY Name"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.tsi_tty_name__c}
                                    error={errors.tsi_tty_name__c && touched.tsi_tty_name__c}
                                    FormHelperTextProps={{
                                        error: errors.tsi_tty_name__c && touched.tsi_tty_name__c,
                                    }}
                                    helperText={
                                        errors.tsi_tty_name__c && touched.tsi_tty_name__c
                                            ? errors.tsi_tty_name__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    TSI/TTY Code
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="tty_code__c"
                                    placeholder="TTY Code"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.tty_code__c}
                                    error={errors.tty_code__c && touched.tty_code__c}
                                    FormHelperTextProps={{
                                        error: errors.tty_code__c && touched.tty_code__c,
                                    }}
                                    helperText={
                                        errors.tty_code__c && touched.tty_code__c
                                            ? errors.tty_code__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    TSI TTY Phone
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="tsi_tty_phone__c"
                                    placeholder="TSI TTY Phone"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.tsi_tty_phone__c}
                                    error={errors.tsi_tty_phone__c && touched.tsi_tty_phone__c}
                                    FormHelperTextProps={{
                                        error: errors.tsi_tty_phone__c && touched.tsi_tty_phone__c,
                                    }}
                                    helperText={
                                        errors.tsi_tty_phone__c && touched.tsi_tty_phone__c
                                            ? errors.tsi_tty_phone__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    BM Cluster Name
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="cluster__c"
                                    placeholder="BM Cluster Name"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.cluster__c}
                                    error={errors.cluster__c && touched.cluster__c}
                                    FormHelperTextProps={{
                                        error: errors.cluster__c && touched.cluster__c,
                                    }}
                                    helperText={
                                        errors.cluster__c && touched.cluster__c
                                            ? errors.cluster__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Cluster BM Mobile
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="cluster_bm_mobile_no__c"
                                    placeholder="Cluster BM Mobile"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.cluster_bm_mobile_no__c}
                                    error={
                                        errors.cluster_bm_mobile_no__c &&
                                        touched.cluster_bm_mobile_no__c
                                    }
                                    FormHelperTextProps={{
                                        error:
                                            errors.cluster_bm_mobile_no__c &&
                                            touched.cluster_bm_mobile_no__c,
                                    }}
                                    helperText={
                                        errors.cluster_bm_mobile_no__c &&
                                        touched.cluster_bm_mobile_no__c
                                            ? errors.cluster_bm_mobile_no__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    Cluster Code
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="cluster_code__c"
                                    placeholder="Cluster Code"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.cluster_code__c}
                                    error={errors.cluster_code__c && touched.cluster_code__c}
                                    FormHelperTextProps={{
                                        error: errors.cluster_code__c && touched.cluster_code__c,
                                    }}
                                    helperText={
                                        errors.cluster_code__c && touched.cluster_code__c
                                            ? errors.cluster_code__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    RSM MIS Name
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="rsm_mis_name__c"
                                    placeholder="RSM MIS Name"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.rsm_mis_name__c}
                                    error={errors.rsm_mis_name__c && touched.rsm_mis_name__c}
                                    FormHelperTextProps={{
                                        error: errors.rsm_mis_name__c && touched.rsm_mis_name__c,
                                    }}
                                    helperText={
                                        errors.rsm_mis_name__c && touched.rsm_mis_name__c
                                            ? errors.rsm_mis_name__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={2} style={{ padding: 5 }} square={true}>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={6} style={{ paddingLeft: 10 }}>
                                <Typography align="left" variant="body2">
                                    RSM Phone
                                </Typography>
                            </Grid>
                            <Grid item disabled={isDisabled || !isCMDI} xs={6}>
                                <TextField
                                    name="rsm_phone__c"
                                    placeholder="RSM Phone"
                                    className={classes.textField}
                                    disabled={isDisabled || !isCMDI}
                                    value={values.rsm_phone__c}
                                    error={errors.rsm_phone__c && touched.rsm_phone__c}
                                    FormHelperTextProps={{
                                        error: errors.rsm_phone__c && touched.rsm_phone__c,
                                    }}
                                    helperText={
                                        errors.rsm_phone__c && touched.rsm_phone__c
                                            ? errors.rsm_phone__c
                                            : null
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {isCMDI &&
                        (isDisabled ? (
                            <Button
                                variant="contained"
                                fullWidth={true}
                                onClick={this.handleEditForm}
                                color="primary"
                                className={classes.button}
                                style={{ paddingTop: 10 }}
                                key="edit"
                                //disabled={!this.props.isValid}
                            >
                                Edit
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                fullWidth={true}
                                color="primary"
                                className={classes.button}
                                style={{ paddingTop: 10 }}
                                key="submit"
                                type="submit"
                                // disabled={isSubmitting}
                            >
                                Save
                            </Button>
                        ))}
                </form>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={status.snackbarOpen}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                >
                    <MySnackbar
                        onClose={this.handleSnackbarClose}
                        variant="success"
                        message={
                            status.operation === 'new'
                                ? 'Outlet Added Successfully!!'
                                : 'Outlet Updated Successfully!!'
                        }
                    />
                </Snackbar>
            </div>
        );
    }
}

const phoneRegExp = /^(\+91[\s-]?)?[0]?[789]\d{9}$/;

const formHandler = withFormik({
    mapPropsToStatus: (props) => ({
        snackbarOpen: false,
        operation: '',
    }),
    mapPropsToValues: (props) => ({
        outletname__c: '',
        outletcode__c: '',
        mobile_no__c: '',
        address__c: '',
        region__c: '',
        city_town__c: '',
        state__c: '',
        district__c: '',
        wss_tty_name__c: '',
        wss_code__c: '',
        wss_phone__c: '',
        tsi_tty_name__c: '',
        tty_code__c: '',
        tsi_tty_phone__c: '',
        cluster__c: '',
        cluster_bm_mobile_no__c: '',
        cluster_code__c: '',
        cmdi_name__c: '',
        rsm_mis_name__c: '',
        rsm_phone__c: '',
    }),
    validationSchema: Yup.object().shape({
        outletname__c: Yup.string().required('Outlet Name is required'),
        // outletcode__c:Yup.required("Outlet code required!"),
        // wss_code__c:Yup.required("Outlet code required!"),
        // tty_code__c:Yup.required("Outlet code required!"),,
        mobile_no__c: Yup.string('Mobile No. should be number')
            .matches(phoneRegExp, 'Phone number is not valid')
            .required('Phone Number is required!'),
        tsi_tty_phone__c: Yup.string('TSI TTY phone should be numbers')
            .matches(phoneRegExp, 'TSI TTY phone number is not valid')
            .required('TSI TTY Phone Number is required!'),
        wss_phone__c: Yup.string('WSS phone should be numbers')
            .matches(phoneRegExp, 'WSS phone number is not valid')
            .required('WSS Phone Number is required!'),
        cluster_bm_mobile_no__c: Yup.string('Cluster phone should be numbers')
            .matches(phoneRegExp, 'Cluster Phone number is not valid')
            .required('Cluster Phone Number is required!'),
        rsm_phone__c: Yup.string('RSM phone should be numbers')
            .matches(phoneRegExp, 'RSM Phone number is not valid')
            .required('RSM Phone Number is required!'),
    }),
    handleSubmit: async (values, { props, setSubmitting, setStatus }) => {
        setSubmitting(true);
        let userData;
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                userData = data.user;
            });

        const outletid = queryString.parse(window.location.search).outletid;

        if (!outletid) {
            const outletInsertQuery = `Insert INTO Salesforce.outlets__c (OutletName__c,Outletcode__c,Mobile_No__c,Address__c,city_town__c,Region__c,State__c,District__c,wss_tty_name__c,WSS_CODE__c,WSS_Phone__c,tsi_tty_name__c,TTY_Code__c,TSI_TTY_Phone__c,Cluster__c,Cluster_BM_Mobile_no__c,Cluster_Code__c,RSM_MIS_Name__c,RSM_Phone__c,CMDI_Name__c) Values('${values.outletname__c}','${values.outletcode__c}','${values.mobile_no__c}','${values.address__c}','${values.city_town__c}','${values.region__c}','${values.state__c}','${values.district__c}','${values.wss_tty_name__c}','${values.wss_code__c}','${values.wss_phone__c}','${values.tsi_tty_name__c}','${values.tty_code__c}','${values.tsi_tty_phone__c}','${values.cluster__c}','${values.cluster_bm_mobile_no__c}','${values.cluster_code__c}','${values.rsm_mis_name__c}','${values.rsm_phone__c}','${userData.sfid}') RETURNING id`;

            const outletInsertQueryResponse = await getData(outletInsertQuery);
            if (outletInsertQueryResponse)
                setStatus({
                    snackbarOpen: true,
                    operation: 'new',
                });
            setSubmitting(false);
        } else {
            const outletUpdateResponse = await getData(
                `update  Salesforce.outlets__c set OutletName__c = '${values.outletname__c}', Outletcode__c = '${values.outletcode__c}',Mobile_No__c='${values.mobile_no__c}',Address__c='${values.address__c}',city_town__c='${values.city_town__c}',Region__c='${values.region__c}',State__c='${values.state__c}',District__c='${values.district__c}',wss_tty_name__c='${values.wss_tty_name__c}',WSS_CODE__c='${values.wss_code__c}',WSS_Phone__c='${values.wss_phone__c}',tsi_tty_name__c='${values.tsi_tty_name__c}',TTY_Code__c='${values.tty_code__c}',TSI_TTY_Phone__c='${values.tsi_tty_phone__c}',Cluster__c='${values.cluster__c}',Cluster_BM_Mobile_no__c='${values.cluster_bm_mobile_no__c}',Cluster_Code__c='${values.cluster_code__c}', RSM_MIS_Name__c='${values.rsm_mis_name__c}', RSM_Phone__c='${values.rsm_phone__c}' where cmdi_name__c like '${userData.sfid}' and id='${values.id}' RETURNING id`
            );
            if (outletUpdateResponse)
                setStatus({
                    snackbarOpen: true,
                    operation: 'update',
                });
        }

        setSubmitting(false);
    },
});

export default compose(
    withRouter,
    formHandler,
    withStyles(styles, { withTheme: true })
)(AddEditOutlet);
